/* eslint-disable quotes */
import { Credit } from 'types/api/loan'
import { CREDIT_TYPES_SLUG } from 'api/advances'

// Utils
import { moneyFormat } from 'utils'
import { ADVANCE_STATES } from 'constants/credit'
import Badge from './Badge'

const { PREAPPROVED, SEND, DRAFT } = ADVANCE_STATES

interface AdvanceDetailsProps {
  loanData: Credit
  action: () => void
  isDisabled?: boolean
  className?: string
}

const LoanDetailButton = ({
  loanData,
  action,
  isDisabled = false,
  className = ''
}: AdvanceDetailsProps) => {
  const {
    state,
    delivered_amount: deliveredAmount,
    installments_count: installmentsCount,
    id,
    type,
    is_overdue: isOverdue,
    has_coming_due: hasComingDue
  } = loanData

  function renderBadge() {
    if (state === SEND || state === PREAPPROVED || state === DRAFT) {
      return (
        <Badge className='font-medium h-[1.125rem]' variant='YELLOW'>
          <span>En proceso</span>
        </Badge>
      )
    }

    if (isOverdue) {
      return (
        <Badge className='font-medium h-[1.125rem]' variant='RED'>
          <span>Vencida</span>
        </Badge>
      )
    }

    if (hasComingDue) {
      return (
        <Badge className='font-medium h-[1.125rem]' variant='YELLOW'>
          <span>Por vencer</span>
        </Badge>
      )
    }
  }

  return (
    <button
      disabled={isDisabled}
      onClick={() => action()}
      className={`gap-3 shadow-loan-card justify-between flex rounded-lg py-3 px-4 items-center w-full h-[4.25rem] bg-white !outline-none !border-none text-black ${className}`}
    >
      <div className='flex flex-col items-start leading-tight'>
        <p className='text-2xs font-medium text-gray-900'>
          {type === CREDIT_TYPES_SLUG.LOAN ? 'Préstamo' : 'Adelanto'}
        </p>
        <p className='text-xs font-bold text-gray-900'>#{id}</p>
      </div>
      {renderBadge()}
      <div className='shrink-0 leading-none gap-1 flex flex-col'>
        <span className='font-bold text-right'>
          {moneyFormat(deliveredAmount)}
        </span>
        <span className='text-2xs font-medium text-gray-900'>
          En {installmentsCount} cuota{installmentsCount > 1 && 's'}
        </span>
      </div>
    </button>
  )
}

export default LoanDetailButton
